/* eslint-disable jsx-a11y/alt-text */
import { findMap, findCiv } from '../helpers/drafting'
import classNames from 'classnames'

export function MatchGame({ game, gameNumber, showMapName = false }) {
	const mapDetails = findMap(game.map, { withFallback: true })
	const leftCivDetails = game.leftCivs.map((civ) => findCiv(civ, { withFallback: true }))
	const rightCivDetails = game.rightCivs.map((civ) => findCiv(civ, { withFallback: true }))

	return (
		<div className={classNames('flex flex-row series-game', `series-${game.state}`)} data-game-number={gameNumber}>
			<div className="series-civPicks series-leftPicks">
				{leftCivDetails.map((civ, i) => {
					if (game.state !== 'picked')
						return (
							<div className="series-civContainer" key={`series-leftPicks'${i}`}>
								<img
									className={classNames('series-civPick series-leftPick', game.state === 'right' && 'series-civLose', game.state === 'left' && 'series-civWin')}
									src={civ.draftFlagUrl}
								/>
								{game.state === 'left' && <img className="series-winIcon" src="" alt="" />}
								{game.state === 'right' && <img className="series-loseIcon" src="" alt="" />}
							</div>
						)
				})}
			</div>

			<div className="series-mapContainer">
				<img className="series-map" src={mapDetails.iconUrl} />
				{showMapName && <div className="series-mapName">{mapDetails.label}</div>}
			</div>

			<div className="series-civPicks series-rightPicks">
				{rightCivDetails.map((civ, i) => {
					if (game.state !== 'picked')
						return (
							<div className="series-civContainer" key={`series-rightPicks'${i}`}>
								<img
									className={classNames('series-civPick series-rightPick', game.state === 'left' && 'series-civLose', game.state === 'right' && 'series-civWin')}
									src={civ.draftFlagUrl}
								/>
								{game.state === 'right' && <img className="series-winIcon" src="" alt="" />}
								{game.state === 'left' && <img className="series-loseIcon" src="" alt="" />}
							</div>
						)
				})}
			</div>
		</div>
	)
}
